import { Tooltip } from "@material-ui/core";
import classNames from "classnames";
import { useRouter } from "found";
import React, { useContext } from "react";
import { CWPlus } from "../../components/svgs/CWPlus";
import { CWPlusCircle } from "../../components/svgs/CWPlusCircle";
import { appPaths } from "../../constants/route.constants";
import { NavContext } from "./home-nav";

const CreateOrJoinTeamButton = () => {
  const { collapsed, scrollbared } = useContext(NavContext);
  const { match, router } = useRouter();
  const highlightOnHover = true;
  const path = appPaths.createOrJoinTeam;
  const label = "Create or join team";
  const isActive = path
    ? router?.isActive?.(match, router?.createLocation?.(path), { exact: true })
    : false;

  return (
    <Tooltip className="cw-body-lg" title={collapsed ? label : ""} placement={"right"}>
      <li
        className={classNames(
          "cw-flex cw-flex-row cw-gap-4 cw-cursor-pointer cw-body-base cw-h-10",
          {
            "group-hover:cw-rounded-r": scrollbared,
          },
        )}
      >
        <a
          className={classNames("cw-body-base cw-inline cw-h-10 cw-no-underline", {
            "cw-w-full": collapsed,
            "cw-cursor-pointer": collapsed,
          })}
          href={path}
          aria-label={`${label}`}
          onClick={(event) => {
            // We need `href="{path}"` because this makes the browser interpret the <a /> as a hyperlink.
            // Without it, we lose full keyboard support (tab and enter). However a side effect,
            // is if you use the href, it'll reload the app since it's like typing a new URL into the browser's address bar.
            // And we want `href="{path}"` in order for the browser to show the correct link preview (in the bottom of browser)
            // Thus we add this `preventDefault` stops the browser from reloading app!
            event.preventDefault();

            path && router.push(path);
          }}
        >
          {collapsed && (
            <div
              className={classNames("cw-flex cw-flex-row cw-flex-grow cw-gap-4 cw-h-10", {
                "cw-bg-accent-emphasis-pressed": isActive,
                "hover:cw-bg-brand-inset-hover hover:cw-bg-opacity-20": highlightOnHover,
              })}
            >
              <div className="cw-ml-6 cw-self-center cw-h-6 cw-w-6">
                <CWPlusCircle />
              </div>
            </div>
          )}
          {!collapsed && (
            <div
              className={classNames(
                "cw-flex cw-flex-row cw-gap-4 cw-ml-6 cw-my-1 cw-h-8 cw-border-[#B6FF80] cw-border-solid cw-border cw-rounded-full cw-self-center cw-cursor-pointer",
                {
                  "cw-bg-accent-emphasis-pressed": isActive,
                  "hover:cw-bg-brand-inset-hover hover:cw-bg-opacity-20": highlightOnHover,
                },
              )}
            >
              <div className=" cw-self-center cw-ml-1 cw-h-6 cw-w-3">
                <CWPlus />
              </div>
              <div className="cw-self-center cw-whitespace-nowrap cw-flex cw-flex-row cw-text-[#B6FF80] cw-m-1 cw-ml--1 cw-mr-3 cw-font-light">
                {label}
              </div>
            </div>
          )}
        </a>
      </li>
    </Tooltip>
  );
};

export default CreateOrJoinTeamButton;
